import axios from "@/axios";
const baseURL = process.env.VUE_APP_API_SERVER_URL_MEDIA
export default {
    async file(files, story, tick) {
    
        return new Promise((resolve, reject) => {
    
            let config = {
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
                onUploadProgress : (progressEvent) => {
            
                    const totalLength = progressEvent.lengthComputable ? progressEvent.total : progressEvent.target.getResponseHeader('content-length') || progressEvent.target.getResponseHeader('x-decompressed-content-length');
    
                    tick(((progressEvent.loaded * 100) / totalLength))
                    
                }
            };
            
            //upload de l'image
            let formData = new FormData();
            formData.append("files", files);
            formData.append("story", story);
            axios.post(baseURL+"upload/",formData,config).then(response => {
                resolve(response.data);
            }).catch((e) => {
                reject(e);
            })
        })
    }
}